<div class="select-punk-modal-fullscreen" *ngIf="isActive">
  <div class="modal-overlay" (click)="closeModal()"></div>
  <div class="modal-content">
    <button class="close-modal" (click)="closeModal()">×</button>
    
    <div class="punk-info">
      <h2>Select {{ environment.tokenName }} to Accept Bid</h2>
      <p>This bid applies to {{ matchingPunkIds.length }} of your {{ environment.tokenName }}s. Select which one to accept:</p>
      <div class="bid-info" *ngIf="bid">
        <p><strong>Bid Amount:</strong> {{ bid.bid_amount_eth }} ETH</p>
        <p *ngIf="bid.bidder_address">
          <strong>Bidder: </strong>
          <a [routerLink]="['/', 'user', bid.bidder_address]" class="bidder-link">
            <app-wallet-address [address]="bid.bidder_address"></app-wallet-address>
          </a>
          <a 
            [routerLink]="['/', 'user', bid.bidder_address]" 
            target="_blank" 
            rel="noopener noreferrer"
            class="external-link-icon"
            [title]="'Open in new window'">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
              <polyline points="15 3 21 3 21 9"></polyline>
              <line x1="10" y1="14" x2="21" y2="3"></line>
            </svg>
          </a>
        </p>
      </div>
    </div>
    
    <div class="punk-selection-grid">
      <div 
        *ngFor="let punkId of matchingPunkIds" 
        class="punk-selection-item"
        (click)="selectPunk(punkId)">
        <img
          [src]="dataSvc.staticUrl + dataSvc.tokenImagePath + (punkId | tokenIdParse) + '.svg'"
          width="100"
          height="100"
          [alt]="'Punk ' + punkId"
        />
        <div class="punk-id">#{{ punkId }}</div>
      </div>
    </div>
    
    <div class="form-actions">
      <button class="cancel" (click)="closeModal()">Cancel</button>
    </div>
  </div>
</div>
